import React from 'react';
import OpsText from "./ops-text";

const OpsOrderStatus = ({status = "pending"}) => {
    return (
        status === "PENDING" ?
            <OpsText type="label8" weight={700} color="color-1 py-1 px-2 fa-w-100"
                     className="bg-warning px-2 rounded fst-italic"
                     content="NOVÁ"/>
            : status === "PROCESSING" ?
                <OpsText type="label8" weight={700} color="color-1 py-1 px-2 fa-w-100"
                         className="bg-primary-4 px-2 rounded fst-italic"
                         content="V PRÍPRAVE"/>
                : status === "SHIPPED" ?
                    <OpsText type="label8" weight={700} color="color-1 py-1 px-2 fa-w-100"
                             className="bg-success px-2 rounded fst-italic"
                             content="ODOSLANÁ"/>
                    : status === "DELIVERED" ?
                        <OpsText type="label8" weight={700} color="color-1 py-1 px-2 fa-w-100"
                                 className="bg-primary-3 px-2 rounded fst-italic"
                                 content="DORUČENÁ"/>
                        : status === "CANCELLED" ?
                            <OpsText type="label8" weight={700} color="color-1 py-1 px-2 fa-w-100"
                                     className="bg-danger px-2 rounded fst-italic"
                                     content="ZRUŠENÁ"/>
                            :
                            <div/>
    );
};

export default OpsOrderStatus;